module.exports = __webpack_public_path__ + "img/PARTE_CENTRIF_CENTRIFUGADORA.062039fe.jpg";